<template>
  <div v-if="productCount !== 0" class="datatable-wrapper">
    <div class="dataTables_wrapper dt-foundation no-footer">
      <table class="datatable datatable-row-click dataTable no-footer" role="grid"
             style="width: 800px;">
        <thead>
          <table-header :order-by="orderBy"
                        :order-direction="orderDirection"
                        :columns="headerColumns"
                        translation-prefix="tlsProduct.headerColumns."
                        @orderingChanged="setOrderingAndLoadData"/>
        </thead>
        <tbody>
          <tr is="tls-product-list-item"
              v-for="(productSummary, index) in products"
              :product="productSummary"
              :key="productSummary.name.concat(index)"/>
        </tbody>
      </table>
      <div class="bottom">
        <div class="dataTables_paginate paging_full_numbers">
          <tls-products-list-paginator @paginationChanged="loadData"/>
        </div>
        <div class="dataTables_length">
          <label>
            <select-input
              id="page_size"
              :value="'' + pageSize"
              :options="pageSizeOptions"
              :$v="$v.pageSize"
              name="page-size"
              @change="setPageSize"
            />
            items per pagina
          </label>
        </div>
      </div>
      <div class="clear"/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SelectInput from '../forms/fields/SelectInput'
import {SET_ORDER_BY, SET_ORDER_DIRECTION, SET_PAGE_SIZE} from '../../store/modules/tls-product/mutation-types'
import TlsProductsListPaginator from './TlsProductsListPaginator'
import TlsProductListItem from './TlsProductListItem'
import {buildTableHeaderColumn} from '../../types/table-header-column'
import TableHeader from '../../components/tableHeader/TableHeader'

export default {
  name: 'TlsProductsList',
  components: {
    SelectInput,
    TlsProductsListPaginator,
    TlsProductListItem,
    TableHeader
  },
  data: function () {
    return {
      pageSizeOptions: [
        { value: '10', text: '10' },
        { value: '25', text: '25' },
        { value: '50', text: '50' },
        { value: '100', text: '100' }
      ],
      headerColumns: [
        buildTableHeaderColumn('firstProduct'),
        buildTableHeaderColumn('owner'),
        buildTableHeaderColumn('retailer'),
        buildTableHeaderColumn('productAmount'),
        buildTableHeaderColumn('productSaleDate'),
        buildTableHeaderColumn('contractValidityStart'),
        buildTableHeaderColumn('contractValidityEnd')
      ]
    }
  },
  computed: {
    ...mapState({
      page: state => state.tlsProduct.productsPage,
      pageSize: state => state.tlsProduct.pageSize,
      currentPage: state => state.tlsProduct.pageNumber,
      orderBy: state => state.tlsProduct.orderBy,
      orderDirection: state => state.tlsProduct.orderDirection
    }),
    products: function () {
      return this.page !== null ? this.page.products : []
    },
    productCount: function () {
      return this.page !== null ? this.page.count : 0
    }
  },
  methods: {
    loadData: function () {
      this.$emit('update')
    },
    setPageSize: function (value) {
      value = parseInt(value)
      this.$store.commit(`tlsProduct/${SET_PAGE_SIZE}`, value)
      this.loadData()
    },
    setOrderingAndLoadData (ordering) {
      this.$store.commit(`tlsProduct/${SET_ORDER_BY}`, ordering.orderBy)
      this.$store.commit(`tlsProduct/${SET_ORDER_DIRECTION}`, ordering.orderDirection)
      this.loadData()
    }
  },
  validations () {
    return {
      pageSize: {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tlsProducts/TlsProductsList.vue